var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "introduction-profile area"
  }, [_c("section", {
    staticClass: "introduction-profile__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("PROFILE")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("公司简介")])]), _c("main", {
    staticClass: "introduction-profile__main clearfix"
  }, [_c("section", {
    staticClass: "company-img"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/aboutUS/introduction_profile.png"),
      alt: ""
    }
  })]), _c("section", {
    staticClass: "desc"
  }, [_c("p", [_vm._v(" 浙江同花顺智能科技有限公司成立于2017年9月29日，注册资金3亿元，为同花顺全资子公司。作为国内领先的互联网金融信息服务提供商， 公司产品及服务覆盖证券公司、公募基金、私募基金、银行、保险、政府、研究机构、上市公司等机构客户，以及广大个人投资者。 ")]), _c("p", [_vm._v(" 为践行“让金融变得更简单”的使命，公司还以AI为抓手，围绕人工智能、大数据、云服务、金融行情及交易等， 在向客户提供层次丰富品类齐全、品质精良的数字化产品的同时，积极探寻金融与科技融合发展的道路，不断以数字化服务助推行业转型升级。 ")]), _c("p", [_vm._v(" 浙江核新同花顺网络信息股份有限公司（同花顺）成立于1994年,是国内影响力最大、使用人数最多的互联网金融信息服务商(股票代码300033)。 截至目前，同花顺已经和业内96%的券商,91%的基金公司上千家合作伙伴共同为5亿投资者提供包含股票、基金、期货、黄金、港美股等全投资品种服务。 ")])])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };